import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect } from "react";
import CustomButtonLight from "../UI/CustomButtonLight";
import CustomButton from "../UI/CustomButton";
import { X } from "lucide-react";
import "../../_css/UserManagement.css";

const DeleteCompanyDataModal = (props) => {
    const [isConfirmed, setIsConfirmed] = useState(false);

    useEffect(() => {
        if (props.show) {
            setIsConfirmed(false);
        }
    }, [props.show]);

    const handleCheckboxChange = (e) => {
        setIsConfirmed(e.target.checked);
    };

    const handleSubmit = () => {
        if (!isConfirmed) {
            console.warn("Delete prevented: Checkbox not confirmed");
            return;
        }
        props.onSubmit();
    };

    return (
        <Modal
            show={props.show}
            onHide={() => props.onHide(false)}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-38"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body className="delete-company-modal-body">
                {/* Close icon positioned top-right */}
                <X
                    className="delete-company-modal-close-icon"
                    onClick={props.onHide}
                />
                <div className="delete-company-modal-image-container">
                    <img
                        className="delete-company-modal-image"
                        src={`${process.env.PUBLIC_URL}/img/delete-icon.png`}
                        alt="Alert Image"
                    />
                </div>
                <div className="delete-company-modal-content">
                    <h4 className="delete-company-modal-title">
                        Are you sure you want to delete data?
                    </h4>
                    <p className="delete-company-modal-description">
                        This action is irreversible and will permanently remove
                        company information from our system. Please confirm if you wish to proceed.
                    </p>
                </div>

                {/* Confirmation Checkbox */}
                <hr className="delete-company-modal-divider" />
                <div className="delete-company-modal-confirmation">
                    <div className="form-check">
                        <input
                            className="form-check-input delete-company-modal-checkbox"
                            type="checkbox"
                            id="deleteConfirmation"
                            checked={isConfirmed}
                            onChange={handleCheckboxChange}
                        />
                        <label
                            className="form-check-label delete-company-modal-checkbox-label"
                            htmlFor="deleteConfirmation"
                        >
                            I understand that this action cannot be undone and I want to proceed with deletion.
                        </label>
                    </div>
                </div>

                <div className="delete-company-modal-buttons">
                    <CustomButtonLight onClick={props.onHide} text="Back" />
                    {/* Double protection: disabled prop AND conditional onClick */}
                    <CustomButton
                        onClick={isConfirmed ? handleSubmit : undefined}
                        text="Continue"
                        disabled={!isConfirmed}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteCompanyDataModal;